<template>
  <div class="searchProgram">
    <div class="form_content">
      <div class="table">
        <el-table
          :header-cell-style="{ color: '#333333' }"
          :data="tableData"
          style="width: 100%"
          height="calc(100vh - 680px)"
        >
          <!-- <el-table-column type="index" align="center" label="序号" width="180">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column> -->
          <el-table-column type="index" align="center" label="方案版本" width="600">
            <template slot-scope="scope">
              <div style="color: #4a6aed">
                <span>寻访方案v</span>
                <span></span>
                <span>{{ scope.row.orderSize }}</span>
                <span>docx</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="address" label="更新人">
            <template slot-scope="scope">
              <div>
                {{ scope.row.createName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="address" label="更新时间" sortable>
            <template slot-scope="scope">
              <div>
                {{ scope.row.createTime }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="address" label="操作" width="300">
            <template slot-scope="scope">
              <div class="options">
                <div class="download" @click="clickDownload(scope.row)">
                  <div class="icon_box">
                    <i class="el-icon-download"></i>
                  </div>
                  <div class="text">寻访方案</div>
                </div>
                <div
                  class="compile"
                  v-if="scope.row.isShow && queryInfo.baseParam.pageNum == 1"
                  @click="clickToCompile(scope.row)"
                >
                  编辑
                </div>
                <div class="examine" v-else @click="clickExamine(scope.row)">查看</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 编辑方案 -->
      <div class="redactScheme_box" v-if="schemeState" @click="clickToRedact">
        <div class="redactScheme">编辑寻访方案</div>
      </div>
    </div>

    <div class="pagination_box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getSearch, projectLookFor } from '@/api/projectCenter'
const defaultQueryInfo = Object.freeze({
  baseParam: {
    pageNum: 1,
    pageSize: 10
  },
  id: 0, // 	寻访方案id
  order: 'desc', // 默认为null。排序：desc，asc
  projectId: 0 //  项目id
})
export default {
  components: {},
  data() {
    return {
      // 请求基本数据
      queryInfo: { ...defaultQueryInfo },
      // 显示状态 (第一种状态是没有编辑过寻访方案的显示空白，点击去填写默认模板， 第二种状态是有数据的，显示列表)
      schemeState: false,
      tableData: [],
      total: 0
    }
  },

  computed: {
    item() {
      return JSON.parse(this.$route.query.item)
    }
  },

  watch: {},
  created() {
    this.search()
  },
  methods: {
    //下载寻访方案
    async clickDownload(row) {
      const { data: res } = await projectLookFor({ id: row.id })
      console.log(res)
      if (res) {
        let blob = new Blob([res])
        let href = window.URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
        const a = document.createElement('a') //创建a标签
        a.style.display = 'none'
        a.href = href // 指定下载'链接
        a.download = `寻访方案v${row.orderSize}.pdf` //指定下载文件名
        // a.download = "test.png";
        a.click() //触发下载
        window.URL.revokeObjectURL(a.href) //释放URL对象
        if (document.body.contains(a)) {
          document.body.removeChild(a) //释放标签
        }
        // else {
        //   this.$message.error('导出失败!')
        // }
      }
    },
    async search() {
      this.queryInfo.projectId = this.item.id
      const { data: res } = await getSearch(this.queryInfo)
      if (res.resultCode == 200) {
        // 判断有没有数据

        if (res.data.list == [] || res.data.list.length == 0) {
          // 一次都没有编辑过的
          this.schemeState = true
        } else {
          this.schemeState = false
          this.tableData = res.data.list
          this.total = res.data.total
          this.tableData[0].isShow = true
        }
      }
    },
    // 排序
    changeTableSort(column) {
      // console.log(column)
      console.log(this.tableData)
      // if (column.order == 'ascending') {
      //   this.queryInfo.order = 'asc'
      //   this.search()
      // } else if (column.order == 'descending') {
      //   this.queryInfo.order = 'desc'
      //   this.search()
      // } else if (column.order == null) {
      //   this.queryInfo.order = 'asc'
      //   this.search()
      // }
    },
    // 分页
    handleSizeChange(val) {
      this.queryInfo.baseParam.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.queryInfo.baseParam.pageNum = val
      this.search()
    },
    // 前往第一次编辑寻访方案
    clickToRedact() {
      // console.log(this.item)
      this.$router.push({
        path: '/businessManagement/workbench/projectAlternatives',
        query: {
          projectId: this.item.id,
          item: JSON.stringify(this.item),
          oneNew: 'true'
        }
      })
    },
    // 点击去编辑
    clickToCompile(row) {
      this.$router.push({
        path: '/businessManagement/workbench/projectAlternatives',
        query: {
          projectId: this.item.id,
          id: row.id,
          item: JSON.stringify(this.item)
        }
      })
    },
    // 点击查看
    clickExamine(row) {
      this.$router.push({
        path: '/businessManagement/workbench/projectAlternatives',
        query: {
          projectId: this.item.id,
          id: row.id,
          tr: true
        }
      })
    }
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.searchProgram {
  background-color: #fff;
  padding-bottom: 12px;
  .table {
    .options {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #17757a;
      font-size: 12px;
      .download {
        display: flex;
        margin-right: 15px;
        cursor: pointer;

        .icon {
          font-size: 12px;
        }
      }
      .compile {
        cursor: pointer;
      }
      .examine {
        cursor: pointer;
        color: #b2b2b2;
      }
    }
  }

  .redactScheme_box {
    margin-top: 150px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .redactScheme {
      width: 170px;
      height: 44px;
      background-color: #17757a;
      font-size: 16px;
      color: #fff;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .pagination_box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 124px;
  }
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  // .form_content {
  //   height: calc(100vh - 128px - 57px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 14px !important;
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  // .form_content {
  //   height: calc(100vh - 128px - 57px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 164px !important;
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  // .form_content {
  //   height: calc(100vh - 128px - 57px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 296px !important;
    margin-top: 58px !important;
  }
}

// 1280x1024 (1280x863)
@media (max-width: 1282px) and (max-height: 864px) {
  // .form_content {
  //   height: calc(100vh - 128px - 57px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 40px !important;
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  // .form_content {
  //   height: calc(100vh - 128px - 57px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 106px !important;
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  // .form_content {
  //   height: calc(100vh - 128px - 54px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 262px !important;
    margin-top: 86px !important;
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  // .form_content {
  //   height: calc(100vh - 128px - 54px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 296px !important;
    margin-top: 56px !important;
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  // .form_content {
  //   height: calc(100vh - 128px - 54px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 342px !important;
    margin-top: 60px !important;
  }
  .redactScheme_box {
    margin-top: 100px !important;
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  // .form_content {
  //   height: calc(100vh - 128px - 54px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 464px !important;
    margin-top: 30px !important;
  }
  .redactScheme_box {
    margin-top: 10px !important;
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  // .form_content {
  //   height: calc(100vh - 128px - 54px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 198px !important;
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  // .form_content {
  //   height: calc(100vh - 128px - 54px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 294px !important;
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  // .form_content {
  //   height: calc(100vh - 128px - 54px) !important;
  //   padding-bottom: 57px !important;
  //   overflow: auto;
  // }
  .pagination_box {
    bottom: 462px !important;
  }
}
</style>
